// src/components/LoadingSpinner/LoadingSpinner.tsx
import React from 'react';
import { Spin, Space } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
  style?: React.CSSProperties;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'large', 
  tip = 'Chargement...', 
  style 
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size === 'large' ? 24 : 16 }} spin />;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        ...style,
      }}
    >
      <Space direction="vertical" align="center">
        <Spin indicator={antIcon} size={size} />
        <span style={{ color: '#666', fontSize: '14px' }}>{tip}</span>
      </Space>
    </div>
  );
};

export default LoadingSpinner;